import(/* webpackMode: "eager" */ "/home/runner/work/build-a-dress/build-a-dress/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/home/runner/work/build-a-dress/build-a-dress/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/build-a-dress/build-a-dress/src/app/blog/blog.module.css");
